import React, { FC } from 'react'
import { RankFluctuationIcon } from '../../../components/common/rank_fluctuation_icon'
import { RankFluctuationText } from '../../../components/common/rank_fluctuation_text'
import { EnterpriseSDGsRanking } from '../../../clients/kuchikomi_api_client'
import { useSdgsImage } from '../../../hooks/use_sdgs_image'

export const SDGsRankItem: FC<{
  sdgsRank: Array<EnterpriseSDGsRanking>
}> = (props) => {
  const [getSdgsImage] = useSdgsImage()

  return (
    <div className="py-2 px-2 bg-main-gray rounded-xl min-h-[85px]">
      {props.sdgsRank.map((item, index) => {
        return (
          <div
            key={`sdgs-rank-${String(index)}`}
            className={index < 0 ? 'mt-2' : ''}
          >
            <div className="flex justify-start">
              <div className="flex flex-col justify-center">
                <div className="flex justify-center w-[42px]">
                  <RankFluctuationIcon type={item.fluctuation} />
                </div>
                <div className="text-center">
                  <RankFluctuationText type={item.fluctuation} />
                </div>
              </div>
              <div className="pl-4">
                {index === 0 && (
                  <p className="text-xs opacity-75">SDGsクチコミランキング</p>
                )}
                <div className="flex items-center mb-1 gap-1">
                  <img src={getSdgsImage(item.category.code)} className="w-4" />
                  <p className="font-bold">{item.category.value}</p>
                </div>
                <div className="flex justify-start">
                  <p className="text-main-black font-bold text-lg">
                    {String(item.rank)}位
                  </p>
                  {item.total !== null && (
                    <p className="text-xs text-main-darkgray leading-8">
                      （全{String(item.total)}位）
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
